import { AfterViewInit, Component, ElementRef } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
  selector: 'formly-focus-next-wrapper',
  templateUrl: './focus-next-wrapper.component.html',
  styleUrls: ['./focus-next-wrapper.component.scss'],
})
export class FocusNextWrapperComponent
  extends FieldWrapper
  implements AfterViewInit
{
  constructor(private el: ElementRef) {
    super();
  }

  ngAfterViewInit() {
    this.setupFocusManagement();
  }

  setupFocusManagement() {
    const form = this.el.nativeElement.closest('form');
    if (!form) return;

    const focusableSelectors = 'input[id^="formly_"]';
    const focusableElements: Element[] = Array.from(
      form.querySelectorAll(focusableSelectors)
    );

    focusableElements.forEach((element: any, index: number) => {
      element.addEventListener('keydown', (event: KeyboardEvent) => {
        if (event.key === 'Enter') {
          event.preventDefault(); // Prevent form submission
          this.focusNextElement(focusableElements, index);
        }
      });
    });
  }

  focusNextElement(elements: Array<Element>, currentIndex: number) {
    const nextIndex = currentIndex + 1;
    if (nextIndex < elements.length) {
      (elements[nextIndex] as HTMLElement).focus();
    } else {
      this.focusSubmitButton();
    }
  }

  focusSubmitButton() {
    const form = this.el.nativeElement.closest('form');
    const submitButton = form.querySelector('button[type="submit"]');
    submitButton?.focus();
  }
}
